import { useEffect, useState } from "react";
import { LayoutGrid } from "lucide-react";
import { api, ApiError } from "../lib/api";
import { FolderOut, FoldersResponse } from "../types";
import { ScreenHeader } from "./ScreenHeader";

export function FolderGrid({ onPick, onBack }: { onPick: (folder: FolderOut) => void; onBack: () => void }) {
  const [folders, setFolders] = useState<FolderOut[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<FoldersResponse>("/api/templates/folders")
      .then((res) => setFolders(res.folders))
      .catch((err) => setError(err instanceof ApiError ? err.message : "تعذر تحميل المجلدات"));
  }, []);

  return (
    <div className="h-full overflow-y-auto">
      <ScreenHeader title="اختر مجلداً" onBack={onBack} />
      <div className="p-4">
        {error && <p className="text-red-400 text-sm">{error}</p>}
        {folders === null && !error && <p className="text-tg-hint text-sm">جاري التحميل...</p>}

        {/* Vertical 3-column grid, matching the same layout used for
            the template grid - scrolls up/down (the screen's own
            overflow-y-auto above), not sideways. */}
        <div className="grid grid-cols-3 gap-3">
          {folders?.map((f) => (
            <button
              key={f.id}
              type="button"
              onClick={() => onPick(f)}
              className="snap-start glass-card p-2 flex flex-col items-center gap-1.5 text-center"
            >
              {f.image_url ? (
                <img
                  src={f.image_url}
                  alt=""
                  className="w-full aspect-square object-cover rounded-xl bg-black/20"
                />
              ) : (
                <div className="w-full aspect-square rounded-xl glass-pill flex items-center justify-center">
                  <LayoutGrid size={24} className="text-vinyl-violet" strokeWidth={2} />
                </div>
              )}
              <div>
                <span className="block text-xs font-semibold truncate w-full">{f.name}</span>
                <span className="block text-[10px] text-tg-hint">{f.template_count} قالب</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
